// import ElInputPro from './inputPro';
const ElInputPro = Vue.defineLazyComponent(() => require("./inputPro"));
window.Vue && window.Vue.component("ElInputPro", ElInputPro);
